<template>
    <div>
        <div class="bg-overlay"></div>
        <div class="favorites-confirm">
            <h3>{{ trans('talents.selection_remove_all.title') }}</h3>
            <a href="#" class="btn-remove-yes" @click.prevent="removeAllFavorites">{{ trans('talents.selection_remove_all.yes') }}</a>
            <a href="#" class="btn-remove-no" @click.prevent="hideConfirm">{{ trans('talents.selection_remove_all.no') }}</a>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'

    export default {

        data: function () {
            return {
            }
        },
        methods: {
            hideConfirm(){
                this.$parent.$emit('hideConfirmDeleteAll')
            },
            removeAllFavorites(){
                this.removeAllFromFavorites()
                this.$parent.$emit('hideConfirmDeleteAll')
            }
        },
    };
</script>